import React, { Fragment, useState, useEffect, useContext } from "react";
import GlobalContext from "../../providers/GlobalProvider";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import Table2 from "../Table/TableComponent";

export default function Client() {
  const [opsclient, setOpsclient] = useState([]);
  const [accountingClient, setAccountingClient] = useState([]);
  const [tblClientMatching, setTblClientMatching] = useState([]);
  const [tblBranchMatching, setTblBranchMatching] = useState([]);
  const [clientMatches, setClientMatches] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [salesmanData, setSalesmanData] = useState([]);
  const [accCurrencyData, setAccCurrencyData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  // const { dbData, globalDb, fetchDbData, updateDbData } =
  // useContext(GlobalContext);
  const [selectedDb, setSelectedDb] = useState("");
  /**
   * @type {GlobalContextValue}
   */
  const { defaultMapper } = useContext(GlobalContext);

  function getClient() {
    let url = "/api/Client";

    axios
      .get(url)
      .then((result) => {
        setClientMatches(result.data.clientMatches);
        setOpsclient(result.data.customer);
        setAccountingClient(result.data.people);
        setBranchData(result.data.branch);
        setSalesmanData(result.data.salesman);
        setAccCurrencyData(result.data.accountsCurrencies);
        setTblClientMatching(result.data.clientMatchings);
        setTblBranchMatching(result.data.clientBranchMatching);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    setLoading(false);
  }

  useEffect(() => {
    getClient();
  }, [defaultMapper]);

  const handleSave = (clientMatchingItem) => {
    let url = "/api/Client";

    return axios
      .post(url, clientMatchingItem)
      .then((result) => {
        console.log("Data saved successfully:", result);
        setTimeout(() => {
          setSuccess("Data saved successfully!");
        }, 1000);
        setError("");
        return result.data;
      })
      .catch((error) => {
        if (error.response && error.response.status === 409) {
          setError(error.response.data + "");
          setSuccess("");
        } else {
          setTimeout(() => {
            setError("Error saving data.");
          }, 1000);
          setSuccess("");
        }
        console.error(
          "Error saving data:",
          error.response ? error.response.data : error.message
        );
      });
  };

  const handleUpdate = (matching) => {
    let url = "/api/Client";

    return axios
      .post(url, matching)
      .then((result) => {
        console.log("Data saved successfully:", result);
        setTimeout(() => {
          setSuccess("Data saved successfully!");
        }, 1000);
        setError("");
        window.location.reload();
        return result.data;
      })
      .catch((error) => {
        if (error.response && error.response.status === 409) {
          setError(error.response.data + "");
          setSuccess("");
        } else {
          setTimeout(() => {
            setError("Error saving data.");
          }, 1000);
          setSuccess("");
        }
        console.error(
          "Error saving data:",
          error.response ? error.response.data : error.message
        );
      });
  };

  function handleDelete(matching) {
    let url = `/api/Client/${matching.opsId}?branchId=${matching.branchId}`;
    axios
      .delete(url)
      .then((response) => {
        setSuccess("Data Deleted Successfully!");

        setError("");
        setTimeout(() => {
          setSuccess("");
          window.location.reload();
        }, 2000);
      })
      .catch((error) => {
        console.error("Error deleting item:", error);
      });
  }

  if (loading) {
    return (
      <div>
        <ClipLoader
          loading={loading}
          size={100}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  }

  // const handleSelectDb = (event) => {
  //   setSelectedDb(event.target.value);
  //   updateDbData(event.target.value);
  // };

  return (
    <Fragment>
      {/* <select onChange={handleSelectDb} value={selectedDb}>
        <option value="">Select an option</option>
        {dbData.map((dbOption) => (
          <option key={dbOption} value={dbOption}>
            {dbOption}
          </option>
        ))}
      </select> */}
      <Table2
        columnTitle="Customer"
        opsArray={opsclient}
        opsIdProperty="id"
        opsDisplayProperty="name"
        accountingArray={accountingClient}
        accountingIdProperty="pid"
        accountingDisplayProperty="name"
        branchArray={branchData}
        branchIdProperty="id"
        branchDisplayProperty="latinName"
        salesmanArray={salesmanData}
        salesmanIdProperty="pid"
        salesmanDisplayProperty="name"
        accCurrArray={accCurrencyData}
        accCurrIdProperty="accountID"
        accCurrDisplayProperty="acc_num"
        existingMatches={clientMatches}
        clientMatchingArray={tblClientMatching}
        BranchMatchingArray={tblBranchMatching}
        matchingOpsIdProperty="opsId"
        matchingLibraIdProperty="auxiliaryId"
        matchingBranchIdProperty="branchId"
        matchingSalesmanIdProperty="salesmanId"
        matchingAccCurrCode="accountCurrencies"
        handleSave={handleSave}
        handleUpdate={handleUpdate}
        handleDelete={handleDelete}
      />
      <h5 style={{ color: "red" }}>{error}</h5>
      <h5 style={{ color: "green" }}>{success}</h5>
    </Fragment>
  );
}
